import { render, staticRenderFns } from "./SynonymFormatSelector.vue?vue&type=template&id=32fcaf51&"
import script from "./SynonymFormatSelector.vue?vue&type=script&lang=js&"
export * from "./SynonymFormatSelector.vue?vue&type=script&lang=js&"
import style0 from "./SynonymFormatSelector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports